<template>
  <div class="main-container-list-monthly-houses">
    <div class="title">
      <span> MENSAL </span>
    </div>
    <b-table
      responsive
      hover
      :items="items"
      :fields="fields"
      class="table-monthly-houses bg-row-table-monthly-houses scrollable-area-x"
    >
      <template #cell()="data">
        <i style="font-style: normal">
          <div class="row-table-monthly">
            <div class="column-row-table-monthly">
              <span>Bandeja</span>
              <span> {{ data.value.bandeja }} </span>
            </div>
            <div class="column-row-table-monthly">
              <span>Quilos</span>
              <span> {{ data.value.kilos }} </span>
            </div>
          </div>
        </i>
      </template>
    </b-table>
  </div>
</template>

<script>
import { Houses } from '../../services/House';

export default {
  data() {
    return {
      houses: [],
      fields: [],
      items: [{}],
      monthMap: {
        Janeiro: '01',
        Fevereiro: '02',
        Março: '03',
        Abril: '04',
        Maio: '05',
        Junho: '06',
        Julho: '07',
        Agosto: '08',
        Setembro: '09',
        Outubro: '10',
        Novembro: '11',
        Dezembro: '12',
      },
    };
  },
  props: {
    date: {
      type: Object,
      required: true,
    },
    harvests: {
      type: Array,
      required: true,
    },
  },
  watch: {
    date: {
      handler(newDate) {
        this.calculateValues(newDate);
      },
      deep: true,
    },
  },
  methods: {
    async calculateValues(date) {
      this.houses.forEach((house) => {
        this.fields.push({
          key: house.house_name,
          label: house.house_name,
          class: 'text-center',
        });

        const houseObj = {
          kilos: 0,
          bandeja: 0,
        };

        this.harvests.forEach((harvest) => {
          const selectedMonth = parseFloat(this.monthMap[date.month]);
          const selectedYear = parseFloat(date.year);
          const harvestDate = new Date(harvest.harvest_date);
          const month = harvestDate.getMonth() + 1;
          const year = harvestDate.getFullYear();

          if (
            month === selectedMonth &&
            year === selectedYear &&
            harvest.houses.id === house.id
          ) {
            houseObj.kilos += harvest.harvest_quantity_kg;
            houseObj.bandeja += harvest.harvest_quantity_plate;
          }
        });

        // Use this.$set para adicionar propriedades reativas ao objeto items
        this.items[0][house.house_name] = houseObj;
      });
    },
  },
  async created() {
    await Houses().then((response) => {
      this.houses = response.data;
    });

    await this.calculateValues(this.date);
  },
};
</script>

<style>
.main-container-list-monthly-houses {
  display: flex;
  flex-direction: column;
  font-family: 'Inter', sans-serif;
  font-style: normal;
}

.title {
  width: 132px;
  height: 24px;
  background: #ffffff;
  box-shadow: 0px -2px 3px rgba(0, 0, 0, 0.25);
  border-radius: 7px 7px 0px 0px;

  display: flex;
  justify-content: center;
  align-items: center;

  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.155em;
  color: #d65600;
}

.title span {
  border-bottom: 1px solid #d65600;
}

.table-monthly-houses th {
  background-color: rgba(190, 130, 80, 0.85) !important;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  color: #111111;
}

.table-monthly-houses tr {
  font-weight: 400 !important;
  font-size: 14px;
  color: #000000 !important;
}

.table-monthly-houses th,
.table-monthly-houses td {
  vertical-align: middle !important;
}

.bg-row-table-monthly-houses {
  background-color: rgba(222, 219, 219, 0.65);
}

.column-row-table-monthly {
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: center;
}

.row-table-monthly {
  display: flex;
  gap: 12px;
  justify-content: center;
  align-items: center;
}

.scrollable-area-x::-webkit-scrollbar {
  height: 6px; /* height of the entire scrollbar */
}

.scrollable-area-x::-webkit-scrollbar-track {
  background: #d4d4d4; /* color of the tracking area */
}

.scrollable-area-x::-webkit-scrollbar-thumb {
  background: #2c2c2c; /* color of the scroll thumb */
  border-radius: 4px; /* roundness of the scroll thumb */
}
</style>
